import { render, staticRenderFns } from "./CreateTransactionModal.vue?vue&type=template&id=fbffa1ac&"
import script from "./CreateTransactionModal.vue?vue&type=script&lang=js&"
export * from "./CreateTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTransactionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports